import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = comics.slice(0, 4);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            编辑精心挑选的高品质韩漫作品，每一部都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featured.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-2 right-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
                  {comic.rating}
                </div>
                {comic.status === '已完结' && (
                  <div className="absolute top-2 left-2 bg-foreground-900/70 text-white text-xs px-2 py-0.5 rounded-full">
                    已完结
                  </div>
                )}
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
              <div className="flex items-center gap-2 mt-2 flex-wrap">
                {comic.tags.slice(0, 2).map((tag) => (
                  <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">
                    {tag}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
          >
            查看全部漫画 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}